import React, { createContext, useReducer } from "react";

export const GamePopupContext = createContext();

const initialState = {
  showModal: false,
  showCustomBet: false,
  showInviteModal: false,
  showJoin: false,
  nature: null,
  payment_message: "",
};

function reducer(gameState, action) {
  if (action.type === "open") {
    // console.log("here", action.name)
    switch (action.name) {
      case "LUDO":
        // console.log("here ludo");
        return {
          ...gameState,
          showModal: true,
          showInviteModal: false,
          showJoin: false,
        };
      case "CUSTOM_BET":
        // console.log("here BET");
        return {
          ...gameState,
          showModal: false,
          showInviteModal: false,
          showJoin: false,
          showCustomBet: true,
        };
      case "INVITE":
        // console.log("here invite");
        return {
          ...gameState,
          showInviteModal: true,
          showJoin: false,
          showModal: false,
          showCustomBet: false,
          nature: action.nature,
          buddyData : action.buddyData
        };
      case "JOIN_ROOM":
        return {
          ...gameState,
          showJoin: true,
          showModal: false,
          showInviteModal: false,
          showCustomBet: false,
        };
      case "PAYMENT":
        // console.log("HERE");
        return {
          ...gameState,
          payment_message: action.message,
        };
      default:
        return gameState;
    }
  } else {
    return {
      ...gameState,
      showModal: false,
      showInviteModal: false,
      showJoin: false,
      showCustomBet: false,
    };
  }
}

export const GamePopupProvider = ({ children }) => {
  const [gameState, dispatchPopUp] = useReducer(reducer, initialState);
  const value = { gameState, dispatchPopUp };
  return (
    <GamePopupContext.Provider value={value}>
      {children}
    </GamePopupContext.Provider>
  );
};
